import api from './axiosConfig';

export const exportEncuestasToExcel = async () => {
  try {
    // Hacer la solicitud al endpoint de exportación
    const response = await api.get('/api/encuestas/exportar/all', {
      responseType: 'blob', // Importante para manejar archivos binarios
      params: {
        formato: 'excel'
      }
    });

    // Crear un enlace para descargar el archivo
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'resultados_encuestas.xlsx');
    document.body.appendChild(link);
    link.click();
    
    // Limpiar
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('Error al exportar a Excel:', error);
    throw error;
  }
};